export default __webpack_public_path__ + "static/media/file-text.f0473fd4.svg";